import {
  NETWORK_START,
  NETWORK_STOP,
  NETWORK_ERROR,
  SIGN_IN,
  SIGN_OUT,
  SIGN_OUT_SOFT,
} from "./authTypes";
import authService from "../../service/DynamicsAuth";
//import * as authService from "../../service/DynamicsAuthRedirect";

export const startNetwork = () => ({ type: NETWORK_START });
export const stopNetwork = () => ({ type: NETWORK_STOP });
export const networkError = (error) => ({ type: NETWORK_ERROR, error });
export const networkSignIn = (identity) => ({ type: SIGN_IN, identity });
export const networkSignOut = () => ({ type: SIGN_OUT });
export const networkSoftLogOut = () => ({ type: SIGN_OUT_SOFT });

export function initializeNetwork() {
  return async (dispatch) => {
    try {
      dispatch(startNetwork());
      const identity = await authService.getToken();
      dispatch(networkSignIn(identity));
      dispatch(stopNetwork());
    } catch (error) {
      dispatch(stopNetwork());
      //if (!(error instanceof InteractiveSignInRequired)) {
      dispatch(networkError(error));
      //}
    }
  };
}

export function getAccount() {
  return async (dispatch) => {
    try {
      //dispatch(startNetwork());
      const identity = await authService.getAccount();
      if (identity.account) {
        
        dispatch(networkSignIn(identity));
        dispatch(stopNetwork());
      }
    } catch (error) {
      dispatch(stopNetwork());
      dispatch(networkError(error));
    }
  };
}

export function signIn() {
  return async (dispatch) => {
    try {
      //dispatch(startNetwork());
      const identity = await authService.signIn();
      dispatch(networkSignIn(identity));
      dispatch(stopNetwork());
    } catch (error) {
      dispatch(stopNetwork());
      dispatch(networkError(error));
    }
  };
}

export function setIdentity(identity) {
  return async (dispatch) => {
    try {
      dispatch(networkSignIn(identity));
    } catch (error) {
      dispatch(networkError(error));
    }
  };
}

export function signOut() {
  return (dispatch) => {
    dispatch(startNetwork());
    authService.signOut();
    dispatch(stopNetwork());
    dispatch(networkSignOut());
  };
}

export function signOutSoft() {
  return (dispatch) => {
    authService.clearLocal();
    dispatch(networkSoftLogOut());
  };
}
